export default "__VITE_ASSET__CXUZmQxY__"